
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/input/variable-pay",
      function () {
        return require("private-next-pages/faq/input/variable-pay.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/input/variable-pay"])
      });
    }
  